import React, { useEffect, useState, useTransition } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  fetchSalaryAdvanceRequest,
  approveSalaryAdvance,
  attestSalaryAdvance,
  verifySalaryAdvance,
  rejectSalaryAdvance,
  paySalaryAdvance,
  querySalaryAdvanceComment,
  commentSalaryAdvanceReject,
  fetchSalaryAdvanceVouchers,
  closeSalaryAdvance,
  clearSalaryAdvanceRequestsError,
} from "../../../../contents/redux/actions/salaryAdvanceRequestActions";
import { fetchPendingRequestsById } from "../../../../contents/redux/actions/requestActions";
import { fetchWorkflowRouteActors } from "../../../../contents/redux/actions/workflowRouteActions";
import styles from "../../../utilities/cssmodules/ViewSalaryAdvance.module.css";
import {
  CalendarMonthRounded,
  DoneAllRounded,
  DoneRounded,
  DoNotDisturbAltRounded,
  HelpOutlineRounded,
  LiveHelpRounded,
  LowPriorityRounded,
  MonetizationOnRounded,
  PaymentRounded,
  PersonRounded,
  PriceCheckRounded,
  TaskAltRounded,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import QueryModal from "./QueryModal";
import VoucherModal from "./VoucherModal";
import RejectCommentModal from "./RejectCommentModal";
import PayModal from "../payment/PayModal";
import { toast } from "react-toastify";

const ViewSalaryAdvance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isPending, startTransition] = useTransition();
  const { requestId, requestType, createdOn, requester, requesterId } =
    location.state || {};

  const loggedInUserRole = localStorage.getItem("loggedInUserRole");
  const loggedInUserRoleId = parseInt(
    localStorage.getItem("loggedInUserRoleId"),
    10,
  );

  // Select rolePermissions from Redux state
  const {
    rolePermissions,
    salaryAdvanceDetails,
    salaryAdvanceVouchers,
    errors,
  } = useSelector((state) => ({
    rolePermissions: state.auth?.loggedInUserRolePermissions || [],
    salaryAdvanceDetails: state.salaryAdvance.salaryAdvanceDetails || null,
    salaryAdvanceVouchers: state.salaryAdvance.salaryAdvanceVouchers || null,
    errors: state.salaryAdvance.errors || {},
  }));

  // Determine if action buttons should be hidden for HR Assistance
  const hasMasterActorViewPermission = rolePermissions.some(
    (perm) =>
      perm.permissionCategoryId === "MasterActor" &&
      perm.permissionId === "View",
  );
  const hideActions =
    loggedInUserRole === "HR Assistance" &&
    !hasMasterActorViewPermission &&
    requester === "Stiffinnie Saunders" &&
    salaryAdvanceDetails?.currentRole !== loggedInUserRoleId;

  // Determine if action buttons should be shown for Manager
  const isManager = loggedInUserRole === "Manager";
  const hasWorkflowPermissions =
    salaryAdvanceDetails?.workflowPermissions?.length > 0;
  const isCurrentRoleInPermissions =
    salaryAdvanceDetails?.workflowPermissions?.some(
      (perm) => perm.roleId === salaryAdvanceDetails?.currentRole,
    );
  const isCurrentRoleMatchingUserRole =
    salaryAdvanceDetails?.currentRole === loggedInUserRoleId;
  const showManagerActions =
    isManager &&
    hasWorkflowPermissions &&
    isCurrentRoleInPermissions &&
    isCurrentRoleMatchingUserRole;

  const goBack = () => {
    navigate(-1);
  };

  console.log("ViewSalaryAdvance - requestId:", requestId);
  console.log("ViewSalaryAdvance - requester:", requester);
  console.log(
    "ViewSalaryAdvance - paymentCode:",
    salaryAdvanceDetails?.paymentCode,
  );
  console.log(
    "ViewSalaryAdvance - Redux salaryAdvanceDetails:",
    salaryAdvanceDetails,
  );
  console.log(
    "ViewSalaryAdvance - Redux salaryAdvanceVouchers:",
    salaryAdvanceVouchers,
  );
  console.log("ViewSalaryAdvance - Redux errors:", errors);

  const [userPermissions, setUserPermissions] = useState([]);
  const [isQueryModalOpen, setIsQueryModalOpen] = useState(false);
  const [isRejectCommentModalOpen, setIsRejectCommentModalOpen] =
    useState(false);
  const [isVoucherModalOpen, setIsVoucherModalOpen] = useState(false);
  const [isPayModalOpen, setIsPayModalOpen] = useState(false);
  const [workflowId, setWorkflowId] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoadingVoucher, setIsLoadingVoucher] = useState(false);

  useEffect(() => {
    if (requestId) {
      startTransition(() => {
        dispatch(fetchSalaryAdvanceRequest(requestId));
      });
    } else {
      console.warn("Missing requestId:", { requestId });
      toast.error("Invalid request ID");
    }
    return () => {
      console.log("useEffect - Cleanup on unmount");
      if (salaryAdvanceVouchers?.url) {
        console.log(
          "Revoking salaryAdvanceVouchers URL:",
          salaryAdvanceVouchers.url,
        );
        URL.revokeObjectURL(salaryAdvanceVouchers.url);
      }
    };
  }, [requestId, dispatch, salaryAdvanceVouchers?.url]);

  useEffect(() => {
    if (errors.pay) {
      toast.error(errors.pay);
      dispatch(clearSalaryAdvanceRequestsError());
    }
    if (errors.fetchSalaryAdvanceRequests) {
      toast.error(errors.fetchSalaryAdvanceRequests);
      dispatch(clearSalaryAdvanceRequestsError());
    }
  }, [errors.pay, errors.fetchSalaryAdvanceRequests, dispatch]);

  useEffect(() => {
    if (salaryAdvanceDetails) {
      const id = salaryAdvanceDetails?.workflowPermissions?.[0]?.workflowId;
      setWorkflowId(id);
      console.log("Workflow ID:", id);

      const loggedInUserId = parseInt(
        localStorage.getItem("loggedInUserId"),
        10,
      );
      console.log(
        "Logged-in User ID:",
        loggedInUserId,
        "Role:",
        loggedInUserRole,
        "Role ID:",
        loggedInUserRoleId,
      );
      console.log("Current Role:", salaryAdvanceDetails.currentRole);

      const permissions = showManagerActions
        ? salaryAdvanceDetails?.workflowPermissions
            ?.filter(
              (perm) => perm.roleId === salaryAdvanceDetails?.currentRole,
            )
            ?.map((perm) => perm.permissionName) || []
        : !isManager
          ? salaryAdvanceDetails?.workflowPermissions
              ?.filter(
                (perm) => perm.roleId === salaryAdvanceDetails?.currentRole,
              )
              ?.map((perm) => perm.permissionName) || []
          : [];
      setUserPermissions(permissions);
      console.log("User Permissions:", permissions);
    }
  }, [
    salaryAdvanceDetails,
    showManagerActions,
    isManager,
    loggedInUserRoleId,
    loggedInUserRole,
  ]);

  useEffect(() => {
    if (workflowId) {
      console.log("Fetching workflow actors for workflowId:", workflowId);
      dispatch(fetchWorkflowRouteActors(workflowId));
    }
  }, [workflowId, dispatch]);

  useEffect(() => {
    console.log(
      "useEffect - salaryAdvanceVouchers changed:",
      salaryAdvanceVouchers,
    );
    if (salaryAdvanceVouchers?.url) {
      console.log("Setting pdfUrl:", salaryAdvanceVouchers.url);
      setPdfUrl(salaryAdvanceVouchers.url);
      console.log("Opening VoucherModal");
      setIsVoucherModalOpen(true);
    } else {
      console.log("No valid URL in salaryAdvanceVouchers");
    }
    return () => {
      console.log("useEffect - Cleanup salaryAdvanceVouchers");
      if (salaryAdvanceVouchers?.url) {
        console.log(
          "Revoking salaryAdvanceVouchers URL:",
          salaryAdvanceVouchers.url,
        );
        URL.revokeObjectURL(salaryAdvanceVouchers.url);
      }
    };
  }, [salaryAdvanceVouchers]);

  const handleVoucherModal = async () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    if (!salaryAdvanceDetails?.paymentCode) {
      console.error("Payment code is missing");
      toast.error("Payment code is missing.");
      return;
    }
    console.log(
      "Fetching voucher - requestId:",
      requestId,
      "paymentCode:",
      salaryAdvanceDetails.paymentCode,
    );
    setIsLoadingVoucher(true);
    try {
      const documentType = "SalaryAdvance";
      const payload = await dispatch(
        fetchSalaryAdvanceVouchers(
          requestId,
          salaryAdvanceDetails.paymentCode,
          documentType,
        ),
      );
      console.log("Voucher fetch successful:", payload);
      setIsLoadingVoucher(false);
      if (payload?.url) {
        console.log("Fallback: Setting pdfUrl and opening modal");
        setPdfUrl(payload.url);
        setIsVoucherModalOpen(true);
      }
    } catch (error) {
      console.error("Failed to fetch voucher:", error);
      toast.error(
        "Failed to fetch voucher: " + (error.message || "Unknown error"),
      );
      setIsLoadingVoucher(false);
    }
  };

  const handleQueryModal = () => {
    console.log("Opening QueryModal");
    setIsQueryModalOpen(true);
  };

  const handleRejectCommentModal = () => {
    console.log("Opening RejectCommentModal");
    setIsRejectCommentModalOpen(true);
  };

  const handlePayModal = () => {
    console.log("Opening PayModal");
    setIsPayModalOpen(true);
  };

  const handleQuerySubmit = (props) => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    const requestTypeId = salaryAdvanceDetails?.requestTypeId;
    const isRequester = props.selectedActor?.value.includes("requester-");
    const payload = {
      notes: props.notes,
      userId,
      requestTypeId,
      requestId,
      model: "SalaryAdvance",
      targetRoleId: isRequester ? null : props.selectedActor?.role,
      targetUserId: isRequester ? props.selectedActor?.role : null,
    };
    startTransition(() => {
      dispatch(querySalaryAdvanceComment(payload))
        .then(() => {
          toast.success("Request queried successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error querying request:", error);
          toast.error(
            "Failed to query request: " + (error.message || "Unknown error"),
          );
        });
    });
    setIsQueryModalOpen(false);
  };

  const handleRejectCommentSubmit = (props) => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    const requestTypeId = salaryAdvanceDetails?.requestTypeId;
    const payload = {
      notes: props.notes,
      userId,
      requestTypeId,
      requestId,
      model: "SalaryAdvance",
    };
    startTransition(() => {
      dispatch(commentSalaryAdvanceReject(payload))
        .then(() => {
          toast.success("Request commented successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error commenting request:", error);
          toast.error(
            "Failed to comment request: " + (error.message || "Unknown error"),
          );
        });
    });
    setIsRejectCommentModalOpen(false);
  };

  const handlePaySubmit = ({ requestId, paymentCode, requiresReceipt }) => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    if (!userId) {
      toast.error("User ID not found. Please log in again.");
      return;
    }
    if (!salaryAdvanceDetails?.paymentCode) {
      toast.error("No payment code associated with this request.");
      return;
    }
    if (
      parseInt(paymentCode, 10) !==
      parseInt(salaryAdvanceDetails.paymentCode, 10)
    ) {
      toast.error("Invalid payment code. Please try again.");
      return;
    }
    startTransition(() => {
      dispatch(
        paySalaryAdvance(requestId, paymentCode, requiresReceipt, userId),
      )
        .then(() => {
          toast.success("Request paid successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error paying request:", error);
          toast.error(
            "Failed to pay request: " + (error.message || "Unknown error"),
          );
        });
    });
    setIsPayModalOpen(false);
  };

  const handleApprove = () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    const userId = parseInt(localStorage.getItem("loggedInUserId"), 10);
    if (!userId) {
      toast.error("User ID not found. Please log in again.");
      return;
    }
    startTransition(() => {
      dispatch(approveSalaryAdvance(requestId, userId))
        .then(() => {
          toast.success("Request approved successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error approving request:", error);
          toast.error(
            "Failed to approve request: " + (error.message || "Unknown error"),
          );
        });
    });
  };

  const handleAttest = () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    startTransition(() => {
      dispatch(attestSalaryAdvance(requestId))
        .then(() => {
          toast.success("Request attested successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error attesting request:", error);
          toast.error(
            "Failed to attest request: " + (error.message || "Unknown error"),
          );
        });
    });
  };

  const handleVerify = () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    startTransition(() => {
      dispatch(verifySalaryAdvance(requestId))
        .then(() => {
          toast.success("Request verified successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error verifying request:", error);
          toast.error(
            "Failed to verify request: " + (error.message || "Unknown error"),
          );
        });
    });
  };

  const handleReject = () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    startTransition(() => {
      dispatch(rejectSalaryAdvance(requestId))
        .then(() => {
          toast.success("Request rejected successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error rejecting request:", error);
          toast.error(
            "Failed to reject request: " + (error.message || "Unknown error"),
          );
        });
    });
  };

  const handleClose = () => {
    if (!requestId) {
      console.error("Request ID is missing");
      toast.error("Request ID is missing.");
      return;
    }
    startTransition(() => {
      dispatch(closeSalaryAdvance(requestId))
        .then(() => {
          toast.success("Request closed successfully.");
          return dispatch(fetchPendingRequestsById());
        })
        .then(() => {
          if (loggedInUserRole === "Top Management") {
            navigate("/allrequests");
          } else {
            navigate("/pendingrequests");
          }
        })
        .catch((error) => {
          console.error("Error closing request:", error);
          toast.error(
            "Failed to close request: " + (error.message || "Unknown error"),
          );
        });
    });
  };

  return (
    <div className={styles["component-wrapper"]}>
      <div className={styles["component-title"]}>
        <div className={styles["flex-row-container"]}>
          <div className={styles["flex-row-custom-1"]}>
            <span
              className={styles["title-back-button"]}
              onClick={goBack}
              aria-label="Go Back"
            >
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>
            <span>View {requestType} Request</span>
          </div>
        </div>
      </div>
      <div className={styles["wrapper"]}>
        <div className={styles["generic_request_content_component_wrapper"]}>
          <div className={styles["generic_request_content_wrapper"]}>
            <div className={styles["request-details-header"]}>
              <div className={styles["section-header"]}>Request Details</div>
              <div className={styles["status-container"]}>
                <p>
                  Status:{" "}
                  <span className={styles["status-badge"]}>
                    {salaryAdvanceDetails?.status === "Unknown Status"
                      ? "Archived"
                      : salaryAdvanceDetails?.status || "N/A"}
                  </span>
                </p>
              </div>
            </div>

            <div className={styles["generic_request_content_container"]}>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <PersonRounded /> Requester:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {requester || "N/A"}
                </div>
              </div>
              
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <CalendarMonthRounded /> Date created:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {createdOn
                    ? new Date(createdOn).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <MonetizationOnRounded /> Amount requested:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {salaryAdvanceDetails?.amount
                    ? `$${salaryAdvanceDetails.amount}`
                    : "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <PaymentRounded /> Currency:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {salaryAdvanceDetails?.currency || "N/A"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <LiveHelpRounded /> Purpose of salary advance:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {salaryAdvanceDetails?.purpose || "No purpose provided"}
                </div>
              </div>
              <div className={styles["generic_request_content"]}>
                <div className={styles["generic_request_content_heading"]}>
                  <LiveHelpRounded /> Comment:
                </div>
                <div className={styles["generic_request_content_data"]}>
                  {salaryAdvanceDetails?.comments?.length > 0 ? (
                    <div className={styles["comment_block"]}>
                      <p>
                        {salaryAdvanceDetails.comments[
                          salaryAdvanceDetails.comments.length - 1
                        ].notes.replace(/^\[Query to [^\]]+\]: /, "")}
                      </p>
                      <p className={styles["comment-meta"]}>
                        <strong>Queried By:</strong>{" "}
                        {
                          salaryAdvanceDetails.comments[
                            salaryAdvanceDetails.comments.length - 1
                          ].queriedBy
                        }
                      </p>
                    </div>
                  ) : (
                    "No comments available"
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles["generic_request_actions_wrapper"]}>
            <div className={styles["actions-header"]}>
              <div className={styles["section-header"]}>Actions</div>
              {!hideActions && (
                <button
                  onClick={handleVoucherModal}
                  className={styles["view-voucher-button"]}
                  disabled={isLoadingVoucher || isPending}
                  aria-label="View Voucher"
                >
                  {isLoadingVoucher ? "Loading..." : "View Voucher"}
                </button>
              )}
            </div>
            {!hideActions &&
              salaryAdvanceDetails?.status !== "Paid" &&
              salaryAdvanceDetails?.status !== "Rejected" &&
              (showManagerActions || !isManager) && (
                <div className={styles["generic_request_actions"]}>
                  {userPermissions.includes("Approve") && (
                    <Tooltip title="Second level consent" arrow placement="top">
                      <button
                        onClick={handleApprove}
                        className={styles["generic_request_button_primary"]}
                        disabled={isPending}
                        aria-label="Approve request"
                      >
                        <TaskAltRounded /> Approve
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Attest") && (
                    <Tooltip
                      title="Highest level consent"
                      arrow
                      placement="top"
                    >
                      <button
                        onClick={handleAttest}
                        className={styles["generic_request_button_save"]}
                        disabled={isPending}
                        aria-label="Attest request"
                      >
                        <DoneAllRounded /> Attest
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Query") && (
                    <Tooltip
                      title="Question or recall due to dissatisfaction"
                      arrow
                      placement="top"
                    >
                      <button
                        onClick={handleQueryModal}
                        className={styles["generic_request_button_secondary"]}
                        disabled={isPending}
                        aria-label="Query request"
                      >
                        <HelpOutlineRounded /> Query
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Verify") && (
                    <Tooltip title="First level consent" arrow placement="top">
                      <button
                        onClick={handleVerify}
                        className={styles["generic_request_button_primary"]}
                        disabled={isPending}
                        aria-label="Verify request"
                      >
                        <DoneRounded /> Verify
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Pay") && (
                    <Tooltip title="Initiate payment" arrow placement="top">
                      <button
                        onClick={handlePayModal}
                        className={styles["generic_request_button_primary"]}
                        disabled={isPending}
                        aria-label="Pay request"
                      >
                        <PriceCheckRounded /> Pay
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Reject") && (
                    <Tooltip title="Decline or dismiss" arrow placement="top">
                      <button
                        onClick={handleRejectCommentModal}
                        className={styles["generic_request_button_danger"]}
                        disabled={isPending}
                        aria-label="Reject request"
                      >
                        <DoNotDisturbAltRounded /> Reject
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions.includes("Close") && (
                    <Tooltip title="End the request flow" arrow placement="top">
                      <button
                        onClick={handleClose}
                        className={styles["generic_request_button_close"]}
                        disabled={isPending}
                        aria-label="Close request"
                      >
                        <LowPriorityRounded /> Close
                      </button>
                    </Tooltip>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>

      <QueryModal
        open={isQueryModalOpen}
        onClose={() => setIsQueryModalOpen(false)}
        onSubmit={handleQuerySubmit}
        workflowId={workflowId}
        requester={requester}
        requesterId={salaryAdvanceDetails?.requesterId}
      />
      <RejectCommentModal
        open={isRejectCommentModalOpen}
        onClose={() => setIsRejectCommentModalOpen(false)}
        onSubmit={handleRejectCommentSubmit}
        workflowId={workflowId}
        requester={requester}
        requesterId={salaryAdvanceDetails?.requesterId}
      />
      <VoucherModal
        open={isVoucherModalOpen}
        onClose={() => {
          console.log("Closing VoucherModal, revoking pdfUrl:", pdfUrl);
          setIsVoucherModalOpen(false);
          setPdfUrl(null);
        }}
        requestId={requestId}
        pdfUrl={pdfUrl}
        paymentCode={salaryAdvanceDetails?.paymentCode}
      />
      <PayModal
        open={isPayModalOpen}
        onClose={() => setIsPayModalOpen(false)}
        onSubmit={handlePaySubmit}
        requestId={requestId}
      />
    </div>
  );
};

export default ViewSalaryAdvance;
